import { compose } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { isInsider } from "modules/user/auth/model";
import * as api from "modules/insiders/api";
import * as selectors from "modules/insiders/selectors";
import { fetchApi } from "core/api/hoc";
import View from "./View";

export default compose(
  hoc.authorized(isInsider),
  fetchApi(api.getAllInsidersReviews, {
    key: "reviews",
    selector: selectors.getAllInsidersReviewsApi,
    sync: true
  }),
  fetchApi(api.getAverageInsiderRating, {
    key: "rating",
    selector: selectors.getAverageInsiderRatingApi,
    sync: true
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/Reviews/Provider.js